import type { Stripe } from "@stripe/stripe-js";

export const methodProductRoute = (
  product: string,
  interval: 'year'|'month' = 'year',
  quantity: number = 1
) => {
  return {
    path: '/product',
    query: {
      seats: quantity,
      interval,
      product,
    }
  }
}

export const routeAddPaymentMethod = { path: '/home/settings/payment-methods' }
export const routeQuestionsLicense = methodProductRoute('questions', 'year', 1)
export const routeBuySeat = methodProductRoute('seat', 'year', 1)
export const routeBuySimulator = methodProductRoute('simulator', 'year', 1)

export const methodLoadPaymentMethods = () => {
  return ws.send('billing.paymentmethods').catch(api.parseError);
}

export const methodRemovePaymentMethod = (id: string) => {
  return ws.send('billing.removepaymentmethod', { id });
}

export const methodLoadDefaultPaymentMethod = () => {
  return ws.send('billing.defaultpaymentmethod')
}

export const methodSetDefaultPaymentMethod = (id: string) => {
  return ws.send('billing.setdefaultpaymentmethod', { id });
}

export const useStripe = () => useState<Stripe | null>('stripe', () => null)

export const awaitStripeLoaded = () => {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if(useStripe().value){
        clearInterval(interval)
        resolve(useStripe().value)
      }
    }, 100)
  })
}

export const computedIsStripeLoaded = computed(() => {
  return !!useStripe().value
})


export const methodLoadProduct = <T = Product>(product: string): Promise<T> => {
  return ws.send<T>('shop.product', { product })
}

export const methodUpdateBillingAddress = () => {
  return ws.send('auth.billing', {
    address_line1: user.value.address_line1,
    address_line2: user.value.address_line2,
    city: user.value.city,
    state: user.value.state,
    postal_code: user.value.postal_code,
    country: user.value.country,
  }).then(() => {
    notify('Billing address updated')
  }).catch(api.parseError)
}

export const methodLoadSubscriptions = () => {
  return ws.send('billing.subscriptions').catch(api.parseError);
}
